import {Store,Module,ActionContext} from 'vuex'
import ListModule from '../list-module'
import ListState from '../list-state'
import PaymentGateway from '../../entities/cashiers/paymentgateway'
import Ajax from '../../../lib/ajax'
import Util from '../../../lib/util'

interface PaymentGatewayState extends ListState<PaymentGateway>{
    editModel:PaymentGateway;
    
}
class PaymentGatewayModule extends ListModule<PaymentGatewayState,any,PaymentGateway>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize: 10,
        list: new Array<PaymentGateway>(),
        loading:false,
        editModel: new PaymentGateway(),
        activeList: new Array<PaymentGateway>(),
        path: 'payment-gateways'         
    }
    actions = Util.extend(true, this.base_actions, {
        //extra actions
    });
    mutations = Util.extend(true, this.base_mutations, {
        //extra mutations
    });
}
const paymentgatewayModule=new PaymentGatewayModule();
export default paymentgatewayModule;